import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f187ceb8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f187ceb8')) {
      api.createRecord('f187ceb8', component.options)
    } else {
      api.reload('f187ceb8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f187ceb8", function () {
      api.rerender('f187ceb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/announcement/index.vue"
export default component.exports